var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { FormSpy, LifeCycleTypes } from '@formily/react-schema-renderer';
import { Button } from 'antd';
export var Submit = function (_a) {
    var showLoading = _a.showLoading, onSubmit = _a.onSubmit, props = __rest(_a, ["showLoading", "onSubmit"]);
    return (React.createElement(FormSpy, { selector: [
            LifeCycleTypes.ON_FORM_MOUNT,
            LifeCycleTypes.ON_FORM_SUBMIT_START,
            LifeCycleTypes.ON_FORM_SUBMIT_END
        ], reducer: function (state, action) {
            switch (action.type) {
                case LifeCycleTypes.ON_FORM_SUBMIT_START:
                    return __assign(__assign({}, state), { submitting: true });
                case LifeCycleTypes.ON_FORM_SUBMIT_END:
                    return __assign(__assign({}, state), { submitting: false });
                default:
                    return state;
            }
        } }, function (_a) {
        var state = _a.state, form = _a.form;
        return (React.createElement(Button, __assign({ onClick: function (e) {
                if (onSubmit) {
                    form.submit(onSubmit);
                }
                if (props.onClick) {
                    props.onClick(e);
                }
            } }, props, { htmlType: onSubmit ? 'button' : 'submit', loading: showLoading ? state.submitting : undefined }), props.children || '提交'));
    }));
};
Submit.defaultProps = {
    showLoading: true,
    type: 'primary',
    htmlType: 'submit'
};
export var Reset = function (_a) {
    var children = _a.children, forceClear = _a.forceClear, validate = _a.validate, props = __rest(_a, ["children", "forceClear", "validate"]);
    return (React.createElement(FormSpy, { selector: [] }, function (_a) {
        var form = _a.form;
        return (React.createElement(Button, __assign({}, props, { onClick: function () { return form.reset({ forceClear: forceClear, validate: validate }); } }), children || '重置'));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/antd/esm/components/Button.js
// module id = 5792
// module chunks = 0